<template>
  <div id="app">
    <div style="height: 500px">
    <iframe
        id="epubFrame"
        v-if="showEpub"
      :src="EpubURL"
      frameborder="0">
      Your browser doesn't support iframes
    </iframe>
    </div>
  </div>
</template>

<script>
import Common from '../../common/CommonFunc.js'
var blobUrl = Common.EpubBlobUrl;
export default {
  name: 'Home',
  data() {
    return {
      bid:this.$route.query.contentsId,
      page:parseInt(this.$route.query.page),
      time:this.$route.query.time,
      alert:false,
      showEpub:false
    };
  },
  computed:{
    EpubURL(){
      return `static/epub/epub.html?bid=${this.time}_${this.bid}&url=${blobUrl}#page${this.page}`
    }
  },
  methods:{
    auth(){
      this.$store.dispatch('communication0008/epubRequestDisplayCheck', {contents_id:this.bid,page:this.page}).then(res => {
        if(res.data.response.result.status!=0){
          if(!this.alert) {
            this.alert=true
            this.$alert("該当記事の原文を閲覧する権限がありません。", "", {
              confirmButtonText: 'OK',
              center:true,
              customClass:'customAlert',
              callback:()=>{
                this.$router.push('/0001')
              }
            });
          }
        }else{
          this.showEpub=true
        }
      }).catch(res=>{
        if(res.response.status==401){
          return
        }
        if(!this.alert){
          this.alert=true
          this.$alert("該当記事の原文を閲覧する権限がありません。", "", {
            confirmButtonText: 'OK',
            center:true,
            customClass:'customAlert',
            callback:()=>{
              this.alert=true
              this.$router.push('/0001')
            }
          });
        }
      })
    },
    sendLog(page){
      this.$store.dispatch('communication0008/epubRequestDisplay', {contents_id:this.bid,page:page}).then(res => {
        if(res.data.response.result.status!=0){
          if(!this.alert) {
            this.alert=true
            this.$alert("該当記事の原文を閲覧する権限がありません。", "", {
              confirmButtonText: 'OK',
              center:true,
              customClass:'customAlert',
              callback:()=>{
                this.$router.push('/0001')
              }
            });
          }
        }
      }).catch(res=>{
        if(res.response.status==401){
          return
        }
        if(!this.alert){
          this.alert=true
          this.$alert("該当記事の原文を閲覧する権限がありません。", "", {
            confirmButtonText: 'OK',
            center:true,
            customClass:'customAlert',
            callback:()=>{
              this.alert=true
              this.$router.push('/0001')
            }
          });
        }
      })
    },
  },
  mounted(){
    this.auth()
    this.alert=false
    window['sendlog']=page=>{
      this.sendLog(page)
    }
    window['error']=()=>{
      this.$alert("雑誌epubファイルが存在しないため、閲覧できませんでした。", "", {
        confirmButtonText: 'OK',
      });
    }
    // 2021/09/09 #10881 START
    //// 2021/08/03 #10881 START
    //setTimeout(function () {
    //  document.getElementById('epubFrame').focus();
    //}, 1000);
    //// 2021/08/03 #10881 END
    window['setframefocus']=()=>{
      document.getElementById('epubFrame').focus();
    }
    // 2021/09/09 #10881 END
  }
}
</script>

<style scoped>
@import "epub.css";

</style>
